import { cardsData } from '@/mocks/homeData';

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            精选推荐
          </h2>
          <p className="text-foreground-500 text-sm mt-2">编辑精选的优质影视内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.slice(0, 6).map((card) => (
            <article
              key={card.id}
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute top-2 left-2 flex gap-1 flex-wrap">
                  {card.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-foreground-950/70 text-background-50 rounded text-[10px] font-medium backdrop-blur-sm"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3">
                  {card.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{card.date}</span>
                  <span className="text-xs text-primary-600 font-medium whitespace-nowrap cursor-pointer">
                    立即观看 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 text-center">
          {cardsData.length > 6 && (
            <article className="inline-block w-full max-w-lg bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:-translate-y-1 transition-all duration-300">
              <div className="flex flex-col sm:flex-row">
                <div className="relative sm:w-48 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200">
                  <img
                    src={cardsData[6].image}
                    alt={cardsData[6].title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                  <div className="absolute top-2 left-2 flex gap-1">
                    {cardsData[6].tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 bg-foreground-950/70 text-background-50 rounded text-[10px] font-medium backdrop-blur-sm"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex-1 p-4">
                  <h3 className="text-sm font-bold text-foreground-900 mb-1">{cardsData[6].title}</h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-2">{cardsData[6].desc}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400">{cardsData[6].date}</span>
                    <span className="text-xs text-primary-600 font-medium whitespace-nowrap">
                      立即观看 <i className="ri-arrow-right-s-line"></i>
                    </span>
                  </div>
                </div>
              </div>
            </article>
          )}
        </div>
      </div>
    </section>
  );
}